export const CountryData = {
  provinceList: [
    {
      id: 1,
      name: "KOSHI PROVINCE",
      districtList: [
        {
          id: 1,
          name: "TAPLEJUNG",
          municipalityList: [
            {
              id: 1,
              name: "Fattanglung Rural Municipality",
            },
            {
              id: 2,
              name: "Maiwakhola Rural Municipality",
            },
            {
              id: 3,
              name: "Meringden Rural Municipality",
            },
            {
              id: 4,
              name: "Mikawakhola Rural Municipality",
            },
            {
              id: 5,
              name: "Phungling Municipality",
            },
            {
              id: 6,
              name: "Serijdangha Rural Municipality",
            },
            {
              id: 7,
              name: "Sidingwa Rural Municipality",
            },
            {
              id: 8,
              name: "Yangwarak Rural Municipality",
            },
            {
              id: 9,
              name: "Aatharai Triveni Rural Municipality",
            },
          ],
        },
        {
          id: 2,
          name: "SANKHUWASABHA",
          municipalityList: [
            {
              id: 10,
              name: "Bhotkhola Rural Municipality",
            },
            {
              id: 11,
              name: "Chainpur Municipality",
            },
            {
              id: 12,
              name: "Chichila Rural Municipality",
            },
            {
              id: 13,
              name: "Dharmadevi Municipality",
            },
            {
              id: 14,
              name: "Khadbari Municipality",
            },
            {
              id: 15,
              name: "Madi Municipality",
            },
            {
              id: 16,
              name: "Makalu Rural Municipality",
            },
            {
              id: 17,
              name: "Panchkhapan Municipality",
            },
            {
              id: 18,
              name: "Sabhapokhari Rural Municipality",
            },
            {
              id: 19,
              name: "Silichong Rural Municipality",
            },
          ],
        },
        {
          id: 3,
          name: "SOLUKHUMBU",
          municipalityList: [
            {
              id: 20,
              name: "Mapya Rural Municipality",
            },
            {
              id: 21,
              name: "Thulung Rural Municipality",
            },
            {
              id: 22,
              name: "Khumbupasanglahmu Rural Municipality",
            },
            {
              id: 23,
              name: "Likhupike Rural Municipality",
            },
            {
              id: 24,
              name: "Mahakulung Rural Municipality",
            },
            {
              id: 25,
              name: "Necha Salyan Rural Municipality",
            },
            {
              id: 26,
              name: "Solududhakunda Municipality",
            },
            {
              id: 27,
              name: "Sotang Rural Municipality",
            },
          ],
        },
        {
          id: 4,
          name: "OKHALDHUNGA",
          municipalityList: [
            {
              id: 28,
              name: "Champadevi Rural Municipality",
            },
            {
              id: 29,
              name: "Chisankhugadhi Rural Municipality",
            },
            {
              id: 30,
              name: "Khijidemba Rural Municipality",
            },
            {
              id: 31,
              name: "Likhu Rural Municipality",
            },
            {
              id: 32,
              name: "Manebhanjyang Rural Municipality",
            },
            {
              id: 33,
              name: "Molung Rural Municipality",
            },
            {
              id: 34,
              name: "Siddhicharan Municipality",
            },
            {
              id: 35,
              name: "Sunkoshi Rural Municipality",
            },
          ],
        },
        {
          id: 5,
          name: "KHOTANG",
          municipalityList: [
            {
              id: 36,
              name: "Ainselukhark Rural Municipality",
            },
            {
              id: 37,
              name: "Barahapokhari Rural Municipality",
            },
            {
              id: 38,
              name: "Diprung Rural Municipality",
            },
            {
              id: 39,
              name: "Halesi Tuwachung Municipality",
            },
            {
              id: 40,
              name: "Jantedhunga Rural Municipality",
            },
            {
              id: 41,
              name: "Kepilasagadhi Rural Municipality",
            },
            {
              id: 42,
              name: "Khotehang Rural Municipality",
            },
            {
              id: 43,
              name: "Lamidanda Rural Municipality",
            },
            {
              id: 44,
              name: "Rupakot Majhuwagadhi Municipality",
            },
            {
              id: 45,
              name: "Sakela Rural Municipality",
            },
          ],
        },
        {
          id: 6,
          name: "BHOJPUR",
          municipalityList: [
            {
              id: 46,
              name: "Aamchowk Rural Municipality",
            },
            {
              id: 47,
              name: "Arun Rural Municipality",
            },
            {
              id: 48,
              name: "Bhojpur Municipality",
            },
            {
              id: 49,
              name: "Hatuwagadhi Rural Municipality",
            },
            {
              id: 50,
              name: "Pauwadungma Rural Municipality",
            },
            {
              id: 51,
              name: "Ram Prasad Rai Rural Municipality",
            },
            {
              id: 52,
              name: "Shadananda Municipality",
            },
            {
              id: 53,
              name: "Salpa silicho Rural Municipality",
            },
            {
              id: 54,
              name: "Tayamkemaiyum Rural Municipality",
            },
          ],
        },
        {
          id: 7,
          name: "DHANKUTA",
          municipalityList: [
            {
              id: 55,
              name: "Cha Thar Jorpati Rural Municipality",
            },
            {
              id: 56,
              name: "Chaubise Rural Municipality",
            },
            {
              id: 57,
              name: "Dhankuta Municipality",
            },
            {
              id: 58,
              name: "Khalsa Chintang Sahidbhumi Rural Municipality",
            },
            {
              id: 59,
              name: "Mahalakshmi Municipality",
            },
            {
              id: 60,
              name: "Pakhribash Municipality",
            },
            {
              id: 61,
              name: "Sangurigadhi Rural Municipality",
            },
          ],
        },
        {
          id: 8,
          name: "TERHATHUM",
          municipalityList: [
            {
              id: 62,
              name: "Aathrai Rural Municipality",
            },
            {
              id: 63,
              name: "Chaa Thar Rural Municipality",
            },
            {
              id: 64,
              name: "Laliguransh Municipality",
            },
            {
              id: 65,
              name: "Menchayayam Rural Municipality",
            },
            {
              id: 66,
              name: "Myanglung Municipality",
            },
            {
              id: 67,
              name: "Phedap Rural Municipality",
            },
          ],
        },
        {
          id: 9,
          name: "PANCHTHAR",
          municipalityList: [
            {
              id: 68,
              name: "Falgunanda Rural Municipality",
            },
            {
              id: 69,
              name: "Hilihang Rural Municipality",
            },
            {
              id: 70,
              name: "Kummayak Rural Municipality",
            },
            {
              id: 71,
              name: "Miklajung Rural Municipality",
            },
            {
              id: 72,
              name: "Phalaelung Rural Municipality",
            },
            {
              id: 73,
              name: "Phidim Municipality",
            },
            {
              id: 74,
              name: "Tumwaewa Rural Municipality",
            },
            {
              id: 75,
              name: "Yangwarak Rural Municipality",
            },
          ],
        },
        {
          id: 10,
          name: "ILAM",
          municipalityList: [
            {
              id: 76,
              name: "Chulachuli Rural Municipality",
            },
            {
              id: 77,
              name: "Deumai Municipality",
            },
            {
              id: 78,
              name: "Fakfokthum Rural Municipality",
            },
            {
              id: 79,
              name: "Ilam Municipality",
            },
            {
              id: 80,
              name: "Mai Jogmai Rural Municipality",
            },
            {
              id: 81,
              name: "Mai Municipality",
            },
            {
              id: 82,
              name: "Mangsebung Rural Municipality",
            },
            {
              id: 83,
              name: "Rong Rural Municipality",
            },
            {
              id: 84,
              name: "Sandakpur Rural Municipality",
            },
            {
              id: 85,
              name: "Suryaudaya Municipality",
            },
          ],
        },
        {
          id: 11,
          name: "JHAPA",
          municipalityList: [
            {
              id: 86,
              name: "Arjundhara Municipality",
            },
            {
              id: 87,
              name: "Barhadashi Rural Municipality",
            },
            {
              id: 88,
              name: "Bhadrapur Municipality",
            },
            {
              id: 89,
              name: "Birtamod Municipality",
            },
            {
              id: 90,
              name: "Buddha Shanti Rural Municipality",
            },
            {
              id: 91,
              name: "Damak Municipality",
            },
            {
              id: 92,
              name: "Gauradaha Municipality",
            },
            {
              id: 93,
              name: "Gaurigunj Rural Municipality",
            },
            {
              id: 94,
              name: "Haldibari Rural Municipality",
            },
            {
              id: 95,
              name: "Jhapa Rural Municipality",
            },
            {
              id: 96,
              name: "Kachanakawal Rural Municipality",
            },
            {
              id: 97,
              name: "Kamal Rural Municipality",
            },
            {
              id: 98,
              name: "Kankai Municipality",
            },
            {
              id: 99,
              name: "Mechinagar Municipality",
            },
            {
              id: 100,
              name: "Sitasatakshi Municipality",
            },
          ],
        },
        {
          id: 12,
          name: "MORANG",
          municipalityList: [
            {
              id: 101,
              name: "Belbari Municipality",
            },
            {
              id: 102,
              name: "Biratnagar Upa Maha Municipality",
            },
            {
              id: 103,
              name: "Budhiganga Rural Municipality",
            },
            {
              id: 104,
              name: "Dha Municipality althan Rural Municipality",
            },
            {
              id: 105,
              name: "Gramthan Rural Municipality",
            },
            {
              id: 106,
              name: "Jahada Rural Municipality",
            },
            {
              id: 107,
              name: "Kanepokhari Rural Municipality",
            },
            {
              id: 108,
              name: "Katahari Rural Municipality",
            },
            {
              id: 109,
              name: "Kerabari Rural Municipality",
            },
            {
              id: 110,
              name: "Letang Municipality",
            },
            {
              id: 111,
              name: "Miklajung Rural Municipality",
            },
            {
              id: 112,
              name: "Patahri shanishchare Municipality",
            },
            {
              id: 113,
              name: "Rangeli Municipality",
            },
            {
              id: 114,
              name: "Ratuwamai Municipality",
            },
            {
              id: 115,
              name: "Sundar Haraicha Municipality",
            },
            {
              id: 116,
              name: "Sunbarshi municipality",
            },
            {
              id: 117,
              name: "Uralabari Municipality",
            },
          ],
        },
        {
          id: 13,
          name: "SUNSARI",
          municipalityList: [
            {
              id: 118,
              name: "Baraha Municipality",
            },
            {
              id: 119,
              name: "Barju Rural Municipality",
            },
            {
              id: 120,
              name: "Devangunj Rural Municipality",
            },
            {
              id: 121,
              name: "Dharan Upamaha Municipality",
            },
            {
              id: 122,
              name: "Duhabi Municipality",
            },
            {
              id: 123,
              name: "Gadhi Rural Municipality",
            },
            {
              id: 124,
              name: "Harinagar Rural Municipality",
            },
            {
              id: 125,
              name: "Inarwa Municipality",
            },
            {
              id: 126,
              name: "Itahari Upa Maha Municipality",
            },
            {
              id: 127,
              name: "Jhokraha Rural Municipality",
            },
            {
              id: 128,
              name: "Koshi Rural Municipality",
            },
            {
              id: 129,
              name: "Ramdhuni Municipality",
            },
          ],
        },
        {
          id: 14,
          name: "UDAYAPUR",
          municipalityList: [
            {
              id: 130,
              name: "Belaka Municipality",
            },
            {
              id: 131,
              name: "Chaudandigadhi Municipality",
            },
            {
              id: 132,
              name: "Katari Municipality",
            },
            {
              id: 133,
              name: "Rautamai Rural Municipality",
            },
            {
              id: 134,
              name: "Sunkoshi Rural Municipality",
            },
            {
              id: 135,
              name: "Tapli Rural Municipality",
            },
            {
              id: 136,
              name: "Triyuga Municipality",
            },
            {
              id: 137,
              name: "Udayapurgadhi Rural Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 2,
      name: "MADHESH PROVINCE",
      districtList: [
        {
          id: 15,
          name: "SAPTARI",
          municipalityList: [
            {
              id: 138,
              name: "Rajgadh Rural Municipality",
            },
            {
              id: 139,
              name: "Bishnupur Rural Municipality",
            },
            {
              id: 140,
              name: "Bode Barsain Municipality",
            },
            {
              id: 141,
              name: "Chhinnamasta Rural Municipality",
            },
            {
              id: 142,
              name: "Dakneshwori Municipality",
            },
            {
              id: 143,
              name: "Hanumannagar Kankalani Municipality",
            },
            {
              id: 144,
              name: "Kanchanrup Municipality",
            },
            {
              id: 145,
              name: "Khadak Municipality",
            },
            {
              id: 146,
              name: "Krishna Savaran Rural Municipality",
            },
            {
              id: 147,
              name: "Mahadev Rural Municipality",
            },
            {
              id: 148,
              name: "Rajbiraj Municipality",
            },
            {
              id: 149,
              name: "Rupani Rural Municipality",
            },
            {
              id: 150,
              name: "Saptakoshi Rural Municipality",
            },
            {
              id: 151,
              name: "Shambhunath Municipality",
            },
            {
              id: 152,
              name: "Balanbihul Rural Municipality",
            },
            {
              id: 153,
              name: "Tilathi Koiladi Rural Municipality",
            },
            {
              id: 154,
              name: "Tirahut Rural Municipality",
            },
            {
              id: 155,
              name: "Surunga Municipality",
            },
          ],
        },
        {
          id: 16,
          name: "SIRAHA",
          municipalityList: [
            {
              id: 156,
              name: "Arnama Rural Municipality",
            },
            {
              id: 157,
              name: "Aurahi Rural Municipality",
            },
            {
              id: 158,
              name: "Bariyarpatti Rural Municipality",
            },
            {
              id: 159,
              name: "Bhagawa Municipality ur Rural Municipality",
            },
            {
              id: 160,
              name: "Dhangadhimai Municipality",
            },
            {
              id: 161,
              name: "Golbazar Municipality",
            },
            {
              id: 162,
              name: "Kalya Municipality ur Municipality",
            },
            {
              id: 163,
              name: "Karjanhya Rural Municipality",
            },
            {
              id: 164,
              name: "Lahan Municipality",
            },
            {
              id: 165,
              name: "Laxmipur Patari Rural Municipality",
            },
            {
              id: 166,
              name: "Mirchaiya Municipality",
            },
            {
              id: 167,
              name: "Naraha Rural Municipality",
            },
            {
              id: 168,
              name: "Nawarajpur Rural Municipality",
            },
            {
              id: 169,
              name: "Sakhuwanankarkatti Rural Municipality",
            },
            {
              id: 170,
              name: "Siraha Municipality",
            },
            {
              id: 171,
              name: "Sukhipur Rural Municipality",
            },
            {
              id: 172,
              name: "Bishnupur Gaunpalika",
            },
          ],
        },
        {
          id: 17,
          name: "DHANUSA",
          municipalityList: [
            {
              id: 173,
              name: "Chireshwar Nath Municipality",
            },
            {
              id: 174,
              name: "Dhanushadham Municipality",
            },
            {
              id: 175,
              name: "Sabaila Municipality",
            },
            {
              id: 176,
              name: "Mithla Municipality",
            },
            {
              id: 177,
              name: "Ganeshman Charnath N.P.",
            },
            {
              id: 178,
              name: "Janakpur Up Municipality",
            },
            {
              id: 179,
              name: "Shahidnagar Nagar palika",
            },
            {
              id: 180,
              name: "Mithala Bihari nagar palika",
            },
            {
              id: 181,
              name: "Hanshpur Nagar Palika",
            },
            {
              id: 182,
              name: "Bideha Nagar Palika",
            },
            {
              id: 183,
              name: "Kamala siddhi Nagar Palika",
            },
            {
              id: 184,
              name: "Nagarain nagar Palika",
            },
            {
              id: 185,
              name: "mukhiya Patti gaun Palika",
            },
            {
              id: 186,
              name: "Bateshwar Gaun Palika",
            },
            {
              id: 187,
              name: "Dhanauji gaun Palika",
            },
            {
              id: 188,
              name: "Janak Nandani gaun Palika",
            },
            {
              id: 189,
              name: "Laxminya Gaun Palika",
            },
            {
              id: 190,
              name: "Aarurahi Gaun Palika",
            },
          ],
        },
        {
          id: 18,
          name: "MAHOTTARI",
          municipalityList: [
            {
              id: 191,
              name: "Loharpatti Municipality",
            },
            {
              id: 192,
              name: "Bardibas Municipality",
            },
            {
              id: 193,
              name: "Aurhi Municipality",
            },
            {
              id: 194,
              name: "Ramgopalpur Municipality",
            },
            {
              id: 195,
              name: "Gaushala Municipality",
            },
            {
              id: 196,
              name: "Balba Municipality",
            },
            {
              id: 197,
              name: "Manara Siswa Municipality",
            },
            {
              id: 198,
              name: "Bhangha Municipality",
            },
            {
              id: 199,
              name: "Mathihani Municipality",
            },
            {
              id: 200,
              name: "Jaleswar Muncipality",
            },
            {
              id: 201,
              name: "Mahottari Rural Municipality",
            },
            {
              id: 202,
              name: "Samshi Rural Municipality",
            },
            {
              id: 203,
              name: "Sonma Rural Municipality",
            },
            {
              id: 204,
              name: "Ekdara Rural Municipality",
            },
            {
              id: 205,
              name: "Pipra Rural Municipality",
            },
          ],
        },
        {
          id: 19,
          name: "SARLAHI",
          municipalityList: [
            {
              id: 206,
              name: "Malangwa Municipality",
            },
            {
              id: 207,
              name: "Haripurwa Municipality",
            },
            {
              id: 208,
              name: "Godaita Municipality",
            },
            {
              id: 209,
              name: "Balara Municipality",
            },
            {
              id: 210,
              name: "Ishworpur Municipality",
            },
            {
              id: 211,
              name: "Lalbandi Municipality",
            },
            {
              id: 212,
              name: "Bagmati Municipality",
            },
            {
              id: 213,
              name: "Barhathwa Municipality",
            },
            {
              id: 214,
              name: "Haripur Municipality",
            },
            {
              id: 215,
              name: "Hariwon Municipality",
            },
            {
              id: 216,
              name: "Kabilashi Municipality",
            },
            {
              id: 217,
              name: "Kaudena Rural Municipality",
            },
            {
              id: 218,
              name: "Chandranagar Rural Municipality",
            },
            {
              id: 219,
              name: "Brahmpuri Rural Municipality",
            },
            {
              id: 220,
              name: "Parsa Rural Municipality",
            },
            {
              id: 221,
              name: "Chakraghatta Rural Municipality",
            },
            {
              id: 222,
              name: "Bishnu Rural Municipality",
            },
            {
              id: 223,
              name: "Ramnagar Rural Municipality",
            },
            {
              id: 224,
              name: "Basbariya Rural Municipality",
            },
            {
              id: 225,
              name: "Dhankaul Rural Municipality",
            },
          ],
        },
        {
          id: 20,
          name: "RAUTAHAT",
          municipalityList: [
            {
              id: 226,
              name: "chandrapur Municipality",
            },
            {
              id: 227,
              name: "garudha Municipality",
            },
            {
              id: 228,
              name: "gaur Municipality",
            },
            {
              id: 229,
              name: "baudhimai Municipality",
            },
            {
              id: 230,
              name: "brindaban Municipality",
            },
            {
              id: 231,
              name: "devahi gonahi Municipality",
            },
            {
              id: 232,
              name: "durgabhagwati Municipality",
            },
            {
              id: 233,
              name: "gadhimai Municipality",
            },
            {
              id: 234,
              name: "gajura Municipality",
            },
            {
              id: 235,
              name: "kathariya Municipality",
            },
            {
              id: 236,
              name: "madab narayan Municipality",
            },
            {
              id: 237,
              name: "mailapur Municipality",
            },
            {
              id: 238,
              name: "fatuwa bijaypur Municipality",
            },
            {
              id: 239,
              name: "isnath Municipality",
            },
            {
              id: 240,
              name: "proha Municipality",
            },
            {
              id: 241,
              name: "rajpur Municipality",
            },
            {
              id: 242,
              name: "yamunamai rural municipality",
            },
            {
              id: 243,
              name: "rajdevi rural municipality",
            },
          ],
        },
        {
          id: 21,
          name: "BARA",
          municipalityList: [
            {
              id: 244,
              name: "SIMRONGODH Municipality",
            },
            {
              id: 245,
              name: "KOLHABI Municipality",
            },
            {
              id: 246,
              name: "NIJGADH Municipality",
            },
            {
              id: 247,
              name: "AADARSHA KOTWAL Rural Municipality",
            },
            {
              id: 248,
              name: "Baragadhi Rural Munucipality",
            },
            {
              id: 249,
              name: "MAHA GADHIMAI GA. PA.",
            },
            {
              id: 250,
              name: "PACHARAUTA Municipality",
            },
            {
              id: 251,
              name: "DEVTAL GA. PA.",
            },
            {
              id: 252,
              name: "Subarna Rural Municipality",
            },
            {
              id: 253,
              name: "KARAIYAMAI GA. PA.",
            },
            {
              id: 254,
              name: "kalaiya Sub-metropolitian City",
            },
            {
              id: 255,
              name: "JITPUR SIMARA UP. MA. Municipality .",
            },
            {
              id: 256,
              name: "PARWANIPUR GA. PA.",
            },
            {
              id: 257,
              name: "PRASAUNI GA. PA.",
            },
            {
              id: 258,
              name: "Bishrampur Rural Munucipality",
            },
            {
              id: 259,
              name: "PHETA GA. PA.",
            },
          ],
        },
        {
          id: 22,
          name: "PARSA",
          municipalityList: [
            {
              id: 260,
              name: "Bahudaramai Rural Municipality",
            },
            {
              id: 261,
              name: "Jeerabhawani Rural Municipality",
            },
            {
              id: 262,
              name: "Bindabasini Rural Municipality",
            },
            {
              id: 263,
              name: "Birgunj Municipality",
            },
            {
              id: 264,
              name: "Chhipaharmai Rural Municipality",
            },
            {
              id: 265,
              name: "Dhobini Rural Municipality",
            },
            {
              id: 266,
              name: "Jagarnathpur Rural Municipality",
            },
            {
              id: 267,
              name: "Pakahamai Municipality ur Rural Municipality",
            },
            {
              id: 268,
              name: "Parsagadhi Rural Municipality",
            },
            {
              id: 269,
              name: "Paterwa sugauli Rural Municipality",
            },
            {
              id: 270,
              name: "Pokhariya Municipality",
            },
            {
              id: 271,
              name: "SakhuwaPrasauni Rural Municipality",
            },
            {
              id: 272,
              name: "Thori Rural Municipality",
            },
            {
              id: 273,
              name: "Kalikamai Rural Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 3,
      name: "BAGMATI PROVINCE",
      districtList: [
        {
          id: 23,
          name: "DOLAKHA",
          municipalityList: [
            {
              id: 274,
              name: "Baiteshwor Rural Municipality",
            },
            {
              id: 275,
              name: "Bhimeshwor Municipality",
            },
            {
              id: 276,
              name: "Bigu Rural Municipality",
            },
            {
              id: 277,
              name: "Gaurishankar Rural Municipality",
            },
            {
              id: 278,
              name: "Jiri Municipality",
            },
            {
              id: 279,
              name: "Kalinchok Rural Municipality",
            },
            {
              id: 280,
              name: "Melung Rural Municipality",
            },
            {
              id: 281,
              name: "Sailung Rural Municipality",
            },
            {
              id: 282,
              name: "Tamakoshi Rural Municipality",
            },
          ],
        },
        {
          id: 24,
          name: "SINDHUPALCHOWK",
          municipalityList: [
            {
              id: 283,
              name: "Balefi Rural Municipality",
            },
            {
              id: 284,
              name: "Barhabise Municipality",
            },
            {
              id: 285,
              name: "Bhotekoshi Rural Municipality",
            },
            {
              id: 286,
              name: "Chautara Sangachokgadhi Municipality",
            },
            {
              id: 287,
              name: "Helambu Rural Municipality",
            },
            {
              id: 288,
              name: "Indrawati Rural Municipality",
            },
            {
              id: 289,
              name: "Jugal Rural Municipality",
            },
            {
              id: 290,
              name: "Lisangkhu Pakhar Rural Municipality",
            },
            {
              id: 291,
              name: "Sunkoshi Rural Municipality",
            },
            {
              id: 292,
              name: "Melamchi Municipality",
            },
            {
              id: 293,
              name: "Panchpokhari ThanRural Municipality",
            },
            {
              id: 294,
              name: "Tripurasundari Rural Municipality",
            },
          ],
        },
        {
          id: 25,
          name: "RASUWA",
          municipalityList: [
            {
              id: 295,
              name: "Gosaikunda Rural Municipality",
            },
            {
              id: 296,
              name: "Kalika Rural Municipality",
            },
            {
              id: 297,
              name: "Naukunda Rural Municipality",
            },
            {
              id: 298,
              name: "Parbati Kunda Rural Municipality",
            },
            {
              id: 299,
              name: "Uttargaya Rural Municipality",
            },
          ],
        },
        {
          id: 26,
          name: "DHADING",
          municipalityList: [
            {
              id: 300,
              name: "Benighat Rorang Rural Municipality",
            },
            {
              id: 301,
              name: "Galchhi Rural Municipality",
            },
            {
              id: 302,
              name: "Dhunibesi Municipality",
            },
            {
              id: 303,
              name: "Gajuri Rural Municipality",
            },
            {
              id: 304,
              name: "Gangajamuna Rural Municipality",
            },
            {
              id: 305,
              name: "Jwalamukhi Rural Municipality",
            },
            {
              id: 306,
              name: "Khaniyabash Rural Municipality",
            },
            {
              id: 307,
              name: "Netrawati Rural Municipality",
            },
            {
              id: 308,
              name: "Nilakantha Municipality",
            },
            {
              id: 309,
              name: "Rubi Valley Rural Municipality",
            },
            {
              id: 310,
              name: "Siddhalek Rural Municipality",
            },
            {
              id: 311,
              name: "Thakre Rural Municipality",
            },
            {
              id: 312,
              name: "Tripura Sundari Rural Municipality",
            },
          ],
        },
        {
          id: 27,
          name: "NUWAKOT",
          municipalityList: [
            {
              id: 313,
              name: "Belkotgadhi Municipality",
            },
            {
              id: 314,
              name: "Bidur Municipality",
            },
            {
              id: 315,
              name: "Dupcheshwar Rural Municipality",
            },
            {
              id: 316,
              name: "Kakani Rural Municipality",
            },
            {
              id: 317,
              name: "Kispang Rural Municipality",
            },
            {
              id: 318,
              name: "Likhu Rural Municipality",
            },
            {
              id: 319,
              name: "Meghang Rural Municipality",
            },
            {
              id: 320,
              name: "Panchakanya Rural Municipality",
            },
            {
              id: 321,
              name: "Shivapuri Rural Municipality",
            },
            {
              id: 322,
              name: "Suryagadhi Rural Municipality",
            },
            {
              id: 323,
              name: "Tadi Rural Municipality",
            },
            {
              id: 324,
              name: "Tarkeshwar Rural Municipality",
            },
          ],
        },
        {
          id: 28,
          name: "KATHMANDU",
          municipalityList: [
            {
              id: 325,
              name: "Budhanilakantha Municipality",
            },
            {
              id: 326,
              name: "Chandragiri Municipality",
            },
            {
              id: 327,
              name: "Dakshinkali Municipality",
            },
            {
              id: 328,
              name: "Gokarneshwor Municipality",
            },
            {
              id: 329,
              name: "Kageshwori Manahora Municipality",
            },
            {
              id: 330,
              name: "Kathmandu Maha Municipality",
            },
            {
              id: 331,
              name: "Kirtipur Municipality",
            },
            {
              id: 332,
              name: "Nagarjun Municipality",
            },
            {
              id: 333,
              name: "Shankharapur Municipality",
            },
            {
              id: 334,
              name: "Tarakeshwor Municipality",
            },
            {
              id: 335,
              name: "Tokha Municipality",
            },
          ],
        },
        {
          id: 29,
          name: "BHAKTAPUR",
          municipalityList: [
            {
              id: 336,
              name: "Bhaktapur Municipality",
            },
            {
              id: 337,
              name: "Changunarayan Municipality",
            },
            {
              id: 338,
              name: "Madhyapur Thimi Municipality",
            },
            {
              id: 339,
              name: "Suryabinayak Municipality",
            },
          ],
        },
        {
          id: 30,
          name: "LALITPUR",
          municipalityList: [
            {
              id: 340,
              name: "Bagmati Rural Municipality",
            },
            {
              id: 341,
              name: "Godawari Municipality",
            },
            {
              id: 342,
              name: "Konjyosom Rural Municipality",
            },
            {
              id: 343,
              name: "Lalitpur Maha Municipality",
            },
            {
              id: 344,
              name: "Mahalaxmi Municipality",
            },
            {
              id: 345,
              name: "Mahankal Rural Municipality",
            },
          ],
        },
        {
          id: 31,
          name: "KAVREPALANCHOK",
          municipalityList: [
            {
              id: 346,
              name: "Banepa Municipality",
            },
            {
              id: 347,
              name: "Bethanchowk Rural Municipality",
            },
            {
              id: 348,
              name: "Bhumlu Rural Municipality",
            },
            {
              id: 349,
              name: "Chaurideurali Rural Municipality",
            },
            {
              id: 350,
              name: "Dhulikhel Municipality",
            },
            {
              id: 351,
              name: "Khanikola Rural Municipality",
            },
            {
              id: 352,
              name: "Mahabharat Rural Municipality",
            },
            {
              id: 353,
              name: "Mandandeupur Municipality",
            },
            {
              id: 354,
              name: "Namobuddha Municipality",
            },
            {
              id: 355,
              name: "Panauti Municipality",
            },
            {
              id: 356,
              name: "Panchkhal Municipality",
            },
            {
              id: 357,
              name: "Roshi Rural Municipality",
            },
            {
              id: 358,
              name: "Temal Rural Municipality",
            },
          ],
        },
        {
          id: 32,
          name: "RAMECHHAP",
          municipalityList: [
            {
              id: 359,
              name: "Doramba Rural Municipality",
            },
            {
              id: 360,
              name: "Gokulganga Rural Municipality",
            },
            {
              id: 361,
              name: "Khadadevi Rural Municipality",
            },
            {
              id: 362,
              name: "Manthali Municipality",
            },
            {
              id: 363,
              name: "Likhu Rural Municipality",
            },
            {
              id: 364,
              name: "Ramechhap Municipality",
            },
            {
              id: 365,
              name: "Sunapati Rural Municipality",
            },
            {
              id: 366,
              name: "Umakunda Rural Municipality",
            },
          ],
        },
        {
          id: 33,
          name: "SINDHULI",
          municipalityList: [
            {
              id: 367,
              name: "Dudhouli Municipality",
            },
            {
              id: 368,
              name: "Ghanglekh Rural Municipality",
            },
            {
              id: 369,
              name: "Golanjor Rural Municipality",
            },
            {
              id: 370,
              name: "Hariharpurgadhi Rural Municipality",
            },
            {
              id: 371,
              name: "Kamalamai Municipality",
            },
            {
              id: 372,
              name: "Marin Rural Municipality",
            },
            {
              id: 373,
              name: "Phikkal Rural Municipality",
            },
            {
              id: 374,
              name: "Sunkoshi Rural Municipality",
            },
            {
              id: 375,
              name: "Ti Municipality atan Rural Municipality",
            },
          ],
        },
        {
          id: 34,
          name: "MAKWANPUR",
          municipalityList: [
            {
              id: 376,
              name: "Bakaiya Rural Municipality",
            },
            {
              id: 377,
              name: "Bhimphedi Rural Municipality",
            },
            {
              id: 378,
              name: "Bagmati Rural Municipality",
            },
            {
              id: 379,
              name: "Hetauda Upamaha Municipality",
            },
            {
              id: 380,
              name: "Indrasarowar Rural Municipality",
            },
            {
              id: 381,
              name: "Kailash Rural Municipality",
            },
            {
              id: 382,
              name: "Makawa Municipality urgadhi Rural Municipality",
            },
            {
              id: 383,
              name: "Manahari Rural Municipality",
            },
            {
              id: 384,
              name: "Raksirang Rural Municipality",
            },
            {
              id: 385,
              name: "Thaha Municipality",
            },
          ],
        },
        {
          id: 35,
          name: "CHITWAN",
          municipalityList: [
            {
              id: 386,
              name: "Bharatpur Metropolitian City",
            },
            {
              id: 387,
              name: "Ichchha Kamana Rural Municipality",
            },
            {
              id: 388,
              name: "Kalika Municipality",
            },
            {
              id: 389,
              name: "Khairahani Municipality",
            },
            {
              id: 390,
              name: "Madi Municipality",
            },
            {
              id: 391,
              name: "Rapti Municipality",
            },
            {
              id: 392,
              name: "Ratnanagar Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 4,
      name: "GANDAKI PROVINCE",
      districtList: [
        {
          id: 36,
          name: "GORKHA",
          municipalityList: [
            {
              id: 393,
              name: "Aarughat Rural Municipality",
            },
            {
              id: 394,
              name: "Ajirkot Rural Municipality",
            },
            {
              id: 395,
              name: "Bhimsen Rural Municipality",
            },
            {
              id: 396,
              name: "Chum Nubri Rural Municipality",
            },
            {
              id: 397,
              name: "Dharche Rural Municipality",
            },
            {
              id: 398,
              name: "Gandaki Rural Municipality",
            },
            {
              id: 399,
              name: "Gorkha Municipality",
            },
            {
              id: 400,
              name: "Palungtar Municipality",
            },
            {
              id: 401,
              name: "Sahid Lakhan Rural Municipality",
            },
            {
              id: 402,
              name: "Siranchok Rural Municipality",
            },
            {
              id: 403,
              name: "Sulikot Rural Municipality",
            },
          ],
        },
        {
          id: 37,
          name: "MANANG",
          municipalityList: [
            {
              id: 404,
              name: "Chame Rural Municipality",
            },
            {
              id: 405,
              name: "Narphu Rural Municipality",
            },
            {
              id: 406,
              name: "Nashong Rural Municipality",
            },
            {
              id: 407,
              name: "Neshyang Rural Municipality",
            },
          ],
        },
        {
          id: 38,
          name: "MUSTANG",
          municipalityList: [
            {
              id: 408,
              name: "Barha Gaun Muktikshetra Rural Municipality",
            },
            {
              id: 409,
              name: "Dalome Rural Municipality",
            },
            {
              id: 410,
              name: "Gharapjhong Rural Municipality",
            },
            {
              id: 411,
              name: "Lomanthang Rural Municipality",
            },
            {
              id: 412,
              name: "Thasang Rural Municipality",
            },
          ],
        },
        {
          id: 39,
          name: "MYAGDI",
          municipalityList: [
            {
              id: 413,
              name: "Beni Municipality",
            },
            {
              id: 414,
              name: "Annapurna Rural Municipality",
            },
            {
              id: 415,
              name: "Dhaulagiri Rural Municipality",
            },
            {
              id: 416,
              name: "Malika Rural Municipality",
            },
            {
              id: 417,
              name: "Mangala Rural Municipality",
            },
            {
              id: 418,
              name: "Raghuganga Rural Municipality",
            },
          ],
        },
        {
          id: 40,
          name: "KASKI",
          municipalityList: [
            {
              id: 419,
              name: "Machhapuchchhre Rural Municipality",
            },
            {
              id: 420,
              name: "Madi Rural Municipality",
            },
            {
              id: 421,
              name: "Pokhara Maha Municipality",
            },
            {
              id: 422,
              name: "Rupa Rural Municipality",
            },
            {
              id: 423,
              name: "Annapurna Rural Municipality",
            },
          ],
        },
        {
          id: 41,
          name: "LAMJUNG",
          municipalityList: [
            {
              id: 424,
              name: "Besi Sahar Municipality",
            },
            {
              id: 425,
              name: "Madhya Nepal Municipality",
            },
            {
              id: 426,
              name: "Rainaas Municipality",
            },
            {
              id: 427,
              name: "Sundar Bazar Municipality",
            },
            {
              id: 428,
              name: "Kablasothaar Municipality",
            },
            {
              id: 429,
              name: "Dudhpokhari Municipality",
            },
            {
              id: 430,
              name: "Dordi Municipality",
            },
            {
              id: 431,
              name: "Marsyangdi Municipality",
            },
          ],
        },
        {
          id: 42,
          name: "TANAHU",
          municipalityList: [
            {
              id: 432,
              name: "Anbukhaireni Rural Municipality",
            },
            {
              id: 433,
              name: "Bandipur Rural Municipality",
            },
            {
              id: 434,
              name: "Bhanu Municipality",
            },
            {
              id: 435,
              name: "Bhimad Municipality",
            },
            {
              id: 436,
              name: "Byas Municipality",
            },
            {
              id: 437,
              name: "Devghat Rural Municipality",
            },
            {
              id: 438,
              name: "Ghiring Rural Municipality",
            },
            {
              id: 439,
              name: "Myagde Rural Municipality",
            },
            {
              id: 440,
              name: "Rhishing Rural Municipality",
            },
            {
              id: 441,
              name: "Shuklagandaki Municipality",
            },
          ],
        },
        {
          id: 43,
          name: "NAWALPARASI (BARDAGHAT SUSTA EAST)",
          municipalityList: [
            {
              id: 442,
              name: "Binayee Triveni Rural Municipality",
            },
            {
              id: 443,
              name: "Bulingtar Rural Municipality",
            },
            {
              id: 444,
              name: "Bungdikali Rural Municipality",
            },
            {
              id: 445,
              name: "Devchuli Municipality",
            },
            {
              id: 446,
              name: "Gaidakot Municipality",
            },
            {
              id: 447,
              name: "Hupsekot Rural Municipality",
            },
            {
              id: 448,
              name: "Kawasoti Municipality",
            },
            {
              id: 449,
              name: "Madhyabindu Municipality",
            },
          ],
        },
        {
          id: 44,
          name: "SYANGJA",
          municipalityList: [
            {
              id: 450,
              name: "Arjunchaupari Rural Municipality",
            },
            {
              id: 451,
              name: "Bhirkot Municipality",
            },
            {
              id: 452,
              name: "Biruwa Rural Municipality",
            },
            {
              id: 453,
              name: "Chapakot Municipality",
            },
            {
              id: 454,
              name: "Galyang Municipality",
            },
            {
              id: 455,
              name: "Harinas Rural Municipality",
            },
            {
              id: 456,
              name: "Kaligandaki Rural Municipality",
            },
            {
              id: 457,
              name: "Phedikhola Rural Municipality",
            },
            {
              id: 458,
              name: "Putalibazar Municipality",
            },
            {
              id: 459,
              name: "Waling Municipality",
            },
            {
              id: 460,
              name: "Aandhikhola Rural Municipality",
            },
          ],
        },
        {
          id: 45,
          name: "PARBAT",
          municipalityList: [
            {
              id: 461,
              name: "Bihadi Rural Municipality",
            },
            {
              id: 462,
              name: "Jaljala Rural Municipality",
            },
            {
              id: 463,
              name: "Kushma Municipality",
            },
            {
              id: 464,
              name: "Mahashila Rural Municipality",
            },
            {
              id: 465,
              name: "Modi Rural Municipality",
            },
            {
              id: 466,
              name: "Painyu Rural Municipality",
            },
            {
              id: 467,
              name: "Phalebas Municipality",
            },
          ],
        },
        {
          id: 46,
          name: "BAGLUNG",
          municipalityList: [
            {
              id: 468,
              name: "Badigad Rural Municipality",
            },
            {
              id: 469,
              name: "Baglung Municipality",
            },
            {
              id: 470,
              name: "Bareng Rural Municipality",
            },
            {
              id: 471,
              name: "Dhorpatan Municipality",
            },
            {
              id: 472,
              name: "Galkot Municipality",
            },
            {
              id: 473,
              name: "Jaimuni Municipality",
            },
            {
              id: 474,
              name: "Kanthekhola Rural Municipality",
            },
            {
              id: 475,
              name: "Nisikhola Rural Municipality",
            },
            {
              id: 476,
              name: "TamanKhola Rural Municipality",
            },
            {
              id: 477,
              name: "TaraKhola Rural Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 5,
      name: "LUMBINI PROVINCE",
      districtList: [
        {
          id: 47,
          name: "RUKUM EAST",
          municipalityList: [
            {
              id: 478,
              name: "Bhume Rural Municipality",
            },
            {
              id: 479,
              name: "Putha Uttarganga Rural Municipality",
            },
            {
              id: 480,
              name: "Sisne Rural Municipality",
            },
          ],
        },
        {
          id: 48,
          name: "ROLPA",
          municipalityList: [
            {
              id: 481,
              name: "Paribartan Rural Municipality",
            },
            {
              id: 482,
              name: "Lungri Rural Municipality",
            },
            {
              id: 483,
              name: "Madi Rural Municipality",
            },
            {
              id: 484,
              name: "Rolpa Municipality",
            },
            {
              id: 485,
              name: "Runtigadi Rural Municipality",
            },
            {
              id: 486,
              name: "Gangadev Rural Municipality",
            },
            {
              id: 487,
              name: "Sunchhahari Rural Municipality",
            },
            {
              id: 488,
              name: "sunil smiriti Rural Municipality",
            },
            {
              id: 489,
              name: "Thawang Rural Municipality",
            },
            {
              id: 490,
              name: "Tribeni Rural Municipality",
            },
          ],
        },
        {
          id: 49,
          name: "PYUTHAN",
          municipalityList: [
            {
              id: 491,
              name: "Ayirabati Rural Municipality",
            },
            {
              id: 492,
              name: "Gaumukhi Rural Municipality",
            },
            {
              id: 493,
              name: "Jhimruk Rural Municipality",
            },
            {
              id: 494,
              name: "Mallarani Rural Municipality",
            },
            {
              id: 495,
              name: "Mandavi Rural Municipality",
            },
            {
              id: 496,
              name: "Naubahini Rural Municipality",
            },
            {
              id: 497,
              name: "Pyuthan Municipality",
            },
            {
              id: 498,
              name: "Sarumarani Rural Municipality",
            },
            {
              id: 499,
              name: "Sworgadwary Municipality",
            },
          ],
        },
        {
          id: 50,
          name: "GULMI",
          municipalityList: [
            {
              id: 500,
              name: "Chandrakot Rural Municipality",
            },
            {
              id: 501,
              name: "Chatrakot Rural Municipality",
            },
            {
              id: 502,
              name: "Dhurkot Rural Municipality",
            },
            {
              id: 503,
              name: "Gulmidarbar Rural Municipality",
            },
            {
              id: 504,
              name: "Isma Rural Municipality",
            },
            {
              id: 505,
              name: "Kaligandaki Rural Municipality",
            },
            {
              id: 506,
              name: "Madane Rural Municipality",
            },
            {
              id: 507,
              name: "Malika Rural Municipality",
            },
            {
              id: 508,
              name: "Musikot Municipality",
            },
            {
              id: 509,
              name: "Resunga Municipality",
            },
            {
              id: 510,
              name: "Ruru Rural Municipality",
            },
            {
              id: 511,
              name: "Satyawati Rural Municipality",
            },
          ],
        },
        {
          id: 51,
          name: "ARGHAKHANCHI",
          municipalityList: [
            {
              id: 512,
              name: "Bhumikasthan Municipality",
            },
            {
              id: 513,
              name: "Chhatradev Rural Municipality",
            },
            {
              id: 514,
              name: "Malarani Rural Municipality",
            },
            {
              id: 515,
              name: "Panini Rural Municipality",
            },
            {
              id: 516,
              name: "Sandhikharka Municipality",
            },
            {
              id: 517,
              name: "Shitaganga Municipality",
            },
          ],
        },
        {
          id: 52,
          name: "PALPA",
          municipalityList: [
            {
              id: 518,
              name: "Bagnaskali Rural Municipality",
            },
            {
              id: 519,
              name: "Mathagadhi Rural Municipality",
            },
            {
              id: 520,
              name: "Nisdi Rural Municipality",
            },
            {
              id: 521,
              name: "Purbakhola Rural Municipality",
            },
            {
              id: 522,
              name: "Rainadevi Chhahara Rural Municipality",
            },
            {
              id: 523,
              name: "Rambha Rural Municipality",
            },
            {
              id: 524,
              name: "Rampur Municipality",
            },
            {
              id: 525,
              name: "Ribdikot Rural Municipality",
            },
            {
              id: 526,
              name: "Tansen Municipality",
            },
            {
              id: 527,
              name: "Tinau Rural Municipality",
            },
          ],
        },
        {
          id: 53,
          name: "NAWALPARASI (BARDAGHAT SUSTA WEST",
          municipalityList: [
            {
              id: 528,
              name: "Bardaghat Municipality",
            },
            {
              id: 529,
              name: "Palhi Nandan Rural Municipality",
            },
            {
              id: 530,
              name: "Pratappur Rural Municipality",
            },
            {
              id: 531,
              name: "Ramgram Municipality",
            },
            {
              id: 532,
              name: "Sarawal Rural Municipality",
            },
            {
              id: 533,
              name: "Sunwal Municipality",
            },
            {
              id: 534,
              name: "Tribenisusta Rural Municipality",
            },
          ],
        },
        {
          id: 54,
          name: "RUPANDEHI",
          municipalityList: [
            {
              id: 535,
              name: "Butwal Upamaha Municipality",
            },
            {
              id: 536,
              name: "Devdaha Municipality",
            },
            {
              id: 537,
              name: "Gaidahawa Rural Municipality",
            },
            {
              id: 538,
              name: "Kanchan Rural Municipality",
            },
            {
              id: 539,
              name: "Kotahimai Rural Municipality",
            },
            {
              id: 540,
              name: "Lumbini SanskritikMunicipality",
            },
            {
              id: 541,
              name: "Marchawari Rural Municipality",
            },
            {
              id: 542,
              name: "Omsatiya Rural Municipality",
            },
            {
              id: 543,
              name: "Rohini Rural Municipality",
            },
            {
              id: 544,
              name: "Sainamaina Municipality",
            },
            {
              id: 545,
              name: "Sammarimai Rural Municipality",
            },
            {
              id: 546,
              name: "Siddharthanagar Municipality",
            },
            {
              id: 547,
              name: "Siyari Rural Municipality",
            },
            {
              id: 548,
              name: "Sudhdhodhan Rural Municipality",
            },
            {
              id: 549,
              name: "Tillotama Municipality",
            },
            {
              id: 550,
              name: "Mayadevi Rural Municipality",
            },
          ],
        },
        {
          id: 55,
          name: "KAPILVASTU",
          municipalityList: [
            {
              id: 551,
              name: "Banganga Municipality",
            },
            {
              id: 552,
              name: "Bijayanagar Rural Municipality",
            },
            {
              id: 553,
              name: "Buddhabhumi Municipality",
            },
            {
              id: 554,
              name: "Kapilbastu Municipality",
            },
            {
              id: 555,
              name: "Krishnanagar Municipality",
            },
            {
              id: 556,
              name: "Maharajgunj Municipality",
            },
            {
              id: 557,
              name: "Mayadevi Rural Municipality",
            },
            {
              id: 558,
              name: "Shivaraj Municipality",
            },
            {
              id: 559,
              name: "Suddhodhan Rural Municipality",
            },
            {
              id: 560,
              name: "Yashodhara Rural Municipality",
            },
          ],
        },
        {
          id: 56,
          name: "DANG",
          municipalityList: [
            {
              id: 561,
              name: "Babai Rural Municipality",
            },
            {
              id: 562,
              name: "Banglachuli Rural Municipality",
            },
            {
              id: 563,
              name: "Dangisharan Rural Municipality",
            },
            {
              id: 564,
              name: "Gadhawa Rural Municipality",
            },
            {
              id: 565,
              name: "Ghorahi Upamaha Municipality",
            },
            {
              id: 566,
              name: "Lamahi Municipality",
            },
            {
              id: 567,
              name: "Rajpur Rural Municipality",
            },
            {
              id: 568,
              name: "Rapti Rural Municipality",
            },
            {
              id: 569,
              name: "Shantinagar Rural Municipality",
            },
            {
              id: 570,
              name: "Tulsipur Upamaha Municipality",
            },
          ],
        },
        {
          id: 57,
          name: "BANKE",
          municipalityList: [
            {
              id: 571,
              name: "Baijanath Rural Municipality",
            },
            {
              id: 572,
              name: "Duduwa Rural Municipality",
            },
            {
              id: 573,
              name: "Janaki Rural Municipality",
            },
            {
              id: 574,
              name: "Khajura Rural Municipality",
            },
            {
              id: 575,
              name: "Kohalpur Municipality",
            },
            {
              id: 576,
              name: "Narainapur Rural Municipality",
            },
            {
              id: 577,
              name: "Nepalganj Upamaha Municipality",
            },
            {
              id: 578,
              name: "Rapti sonari Rural Municipality",
            },
          ],
        },
        {
          id: 58,
          name: "BARDIYA",
          municipalityList: [
            {
              id: 579,
              name: "Badhaiyatal Rural Municipality",
            },
            {
              id: 580,
              name: "Bansagadhi Municipality",
            },
            {
              id: 581,
              name: "Barbardiya Municipality",
            },
            {
              id: 582,
              name: "Geruwa Rural Municipality",
            },
            {
              id: 583,
              name: "Gulariya Municipality",
            },
            {
              id: 584,
              name: "Madhuwan Municipality",
            },
            {
              id: 585,
              name: "Rajapur Municipality",
            },
            {
              id: 586,
              name: "Thakurbaba Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 6,
      name: "KARNALI PROVINCE",
      districtList: [
        {
          id: 59,
          name: "DOLPA",
          municipalityList: [
            {
              id: 587,
              name: "Chharka Tangsong Rural Municipality",
            },
            {
              id: 588,
              name: "Dolpo Buddha Rural Municipality",
            },
            {
              id: 589,
              name: "Jagadulla Rural Municipality",
            },
            {
              id: 590,
              name: "Kaike Rural Municipality",
            },
            {
              id: 591,
              name: "Mudkechula Rural Municipality",
            },
            {
              id: 592,
              name: "Shey Phoksundo Rural Municipality",
            },
            {
              id: 593,
              name: "Thuli Bheri Municipality",
            },
            {
              id: 594,
              name: "Tripurasundari Municipality",
            },
          ],
        },
        {
          id: 60,
          name: "MUGU",
          municipalityList: [
            {
              id: 595,
              name: "Chhayanath Rara Municipality",
            },
            {
              id: 596,
              name: "Khatyad Rural Municipality",
            },
            {
              id: 597,
              name: "Mugum Karmarong Rural Municipality",
            },
            {
              id: 598,
              name: "Soru Rural Municipality",
            },
          ],
        },
        {
          id: 61,
          name: "HUMLA",
          municipalityList: [
            {
              id: 599,
              name: "Adanchuli Rural Municipality",
            },
            {
              id: 600,
              name: "Chankheli Rural Municipality",
            },
            {
              id: 601,
              name: "Kharpunath Rural Municipality",
            },
            {
              id: 602,
              name: "Namkha Rural Municipality",
            },
            {
              id: 603,
              name: "Sarkegad Rural Municipality",
            },
            {
              id: 604,
              name: "Simkot Rural Municipality",
            },
            {
              id: 605,
              name: "Tanjakot Rural Municipality",
            },
          ],
        },
        {
          id: 62,
          name: "JUMLA",
          municipalityList: [
            {
              id: 606,
              name: "Chandannath Municipality",
            },
            {
              id: 607,
              name: "Guthichaur Tila Rural Municipality",
            },
            {
              id: 608,
              name: "Hima Rural Municipality",
            },
            {
              id: 609,
              name: "Kanakasundari Rural Municipality",
            },
            {
              id: 610,
              name: "Patarasi Rural Municipality",
            },
            {
              id: 611,
              name: "Sinja Rural Municipality",
            },
            {
              id: 612,
              name: "Tatopani Rural Municipality",
            },
            {
              id: 613,
              name: "Tila Rural Municipality",
            },
          ],
        },
        {
          id: 63,
          name: "KALIKOT",
          municipalityList: [
            {
              id: 614,
              name: "Kalika Rural Municipality",
            },
            {
              id: 615,
              name: "Khandachakra Municipality",
            },
            {
              id: 616,
              name: "Mahawai Rural Municipality",
            },
            {
              id: 617,
              name: "Naraharinath Rural Municipality",
            },
            {
              id: 618,
              name: "Pachaljharana Rural Municipality",
            },
            {
              id: 619,
              name: "Palata Rural Municipality",
            },
            {
              id: 620,
              name: "Raskot Municipality",
            },
            {
              id: 621,
              name: "Sanni Tribeni Rural Municipality",
            },
            {
              id: 622,
              name: "Tilagufa Municipality",
            },
          ],
        },
        {
          id: 64,
          name: "DAILEKH",
          municipalityList: [
            {
              id: 623,
              name: "Aathabis Municipality",
            },
            {
              id: 624,
              name: "Bhagawatimai Rural Municipality",
            },
            {
              id: 625,
              name: "Bhairabi Rural Municipality",
            },
            {
              id: 626,
              name: "Chamunda Bindrasain Municipality",
            },
            {
              id: 627,
              name: "Dallu Municipality",
            },
            {
              id: 628,
              name: "Dungeshwor Rural Municipality",
            },
            {
              id: 629,
              name: "Gurans Rural Municipality",
            },
            {
              id: 630,
              name: "Mahabu Gaun Palika",
            },
            {
              id: 631,
              name: "Narayan Municipality",
            },
            {
              id: 632,
              name: "Naumule Rural Municipality",
            },
            {
              id: 633,
              name: "Thantikandh Rural Municipality",
            },
          ],
        },
        {
          id: 65,
          name: "SURKHET",
          municipalityList: [
            {
              id: 634,
              name: "Barekot Rural Municipality",
            },
            {
              id: 635,
              name: "Bheri Municipality",
            },
            {
              id: 636,
              name: "Chhedagad Municipality",
            },
            {
              id: 637,
              name: "Junichande Rural Municipality",
            },
            {
              id: 638,
              name: "Kuse Rural Municipality",
            },
            {
              id: 639,
              name: "Shiwalaya Rural Municipality",
            },
            {
              id: 640,
              name: "Tribeni Nalagad Municipality",
            },
          ],
        },
        {
          id: 66,
          name: "SALYAN",
          municipalityList: [
            {
              id: 641,
              name: "Aathbiskot Municipality",
            },
            {
              id: 642,
              name: "Banfikot Rural Municipality",
            },
            {
              id: 643,
              name: "Chaurjahari Municipality",
            },
            {
              id: 644,
              name: "Musikot Municipality",
            },
            {
              id: 645,
              name: "Sani Bheri Rural Municipality",
            },
            {
              id: 646,
              name: "Tribeni Rural Municipality",
            },
          ],
        },
        {
          id: 67,
          name: "DOLPA",
          municipalityList: [
            {
              id: 647,
              name: "Bagchaur Municipality",
            },
            {
              id: 648,
              name: "Bangad Kupinde Municipality",
            },
            {
              id: 649,
              name: "Chhatreshwori Rural Municipality",
            },
            {
              id: 650,
              name: "Darma Rural Municipality",
            },
            {
              id: 651,
              name: "SIddhaKumakh Rural Municipality",
            },
            {
              id: 652,
              name: "Kalimati Rural Municipality",
            },
            {
              id: 653,
              name: "Kapurkot Rural Municipality",
            },
            {
              id: 654,
              name: "Kumakhmalika Rural Municipality",
            },
            {
              id: 655,
              name: "Sharada Municipality",
            },
            {
              id: 656,
              name: "Tribeni Rural Municipality",
            },
          ],
        },
        {
          id: 68,
          name: "JAJARKOT",
          municipalityList: [
            {
              id: 657,
              name: "Barahtal Rural Municipality",
            },
            {
              id: 658,
              name: "Bheriganga Municipality",
            },
            {
              id: 659,
              name: "Birendranagar Municipality",
            },
            {
              id: 660,
              name: "Chaukune Rural Municipality",
            },
            {
              id: 661,
              name: "Chingad Rural Municipality",
            },
            {
              id: 662,
              name: "Gurbhakot Municipality",
            },
            {
              id: 663,
              name: "Lekbeshi Municipality",
            },
            {
              id: 664,
              name: "Panchpuri Municipality",
            },
            {
              id: 665,
              name: "Simta Rural Municipality",
            },
          ],
        },
      ],
    },
    {
      id: 7,
      name: "SUDUR PASHCHIMANCHAL PROVINCE",
      districtList: [
        {
          id: 69,
          name: "BAJURA",
          municipalityList: [
            {
              id: 666,
              name: "Badimalika Municipality",
            },
            {
              id: 667,
              name: "Budhiganga Municipality",
            },
            {
              id: 668,
              name: "Budhinanda Municipality",
            },
            {
              id: 669,
              name: "Chhededaha Rural Municipality",
            },
            {
              id: 670,
              name: "Gaumul Rural Municipality",
            },
            {
              id: 671,
              name: "Himali Rural Municipality",
            },
            {
              id: 672,
              name: "Pandav Gupha Rural Municipality",
            },
            {
              id: 673,
              name: "Swami Kartik Rural Municipality",
            },
            {
              id: 674,
              name: "Tribeni Municipality",
            },
          ],
        },
        {
          id: 70,
          name: "BAJHANG",
          municipalityList: [
            {
              id: 675,
              name: "Bithadchir Rural Municipality",
            },
            {
              id: 676,
              name: "Bungal Municipality",
            },
            {
              id: 677,
              name: "Chabis pathivera Rural Municipality",
            },
            {
              id: 678,
              name: "Durgathali Rural Municipality",
            },
            {
              id: 679,
              name: "JayaPrithivi Municipality",
            },
            {
              id: 680,
              name: "Kanda Rural Municipality",
            },
            {
              id: 681,
              name: "Kedarsyun Rural Municipality",
            },
            {
              id: 682,
              name: "Khaptad chhanna Rural Municipality",
            },
            {
              id: 683,
              name: "Masta Rural Municipality",
            },
            {
              id: 684,
              name: "Surma Rural Municipality",
            },
            {
              id: 685,
              name: "Talkot Rural Municipality",
            },
            {
              id: 686,
              name: "Thalara Rural Municipality",
            },
          ],
        },
        {
          id: 71,
          name: "DARCHULA",
          municipalityList: [
            {
              id: 687,
              name: "Apihimal Rural Municipality",
            },
            {
              id: 688,
              name: "Byas Rural Municipality",
            },
            {
              id: 689,
              name: "Dunhun Rural Municipality",
            },
            {
              id: 690,
              name: "Lekam Rural Municipality",
            },
            {
              id: 691,
              name: "Mahakali Municipality",
            },
            {
              id: 692,
              name: "Malikarjun Rural Municipality",
            },
            {
              id: 693,
              name: "Marma Rural Municipality",
            },
            {
              id: 694,
              name: "Naugad Rural Municipality",
            },
            {
              id: 695,
              name: "Shailyashikhar Municipality",
            },
          ],
        },
        {
          id: 72,
          name: "BAITADI",
          municipalityList: [
            {
              id: 696,
              name: "Dasharathchanda Municipality",
            },
            {
              id: 697,
              name: "Dilasaini Rural Municipality",
            },
            {
              id: 698,
              name: "Dogadakedar Rural Municipality",
            },
            {
              id: 699,
              name: "Melauli Municipality",
            },
            {
              id: 700,
              name: "Pancheshwar Rural Municipality",
            },
            {
              id: 701,
              name: "Patam Municipality",
            },
            {
              id: 702,
              name: "Puchaudi Municipality",
            },
            {
              id: 703,
              name: "Shivanath Rural Municipality",
            },
            {
              id: 704,
              name: "Sigas Rural Municipality",
            },
            {
              id: 705,
              name: "Surnaya Rural Municipality",
            },
          ],
        },
        {
          id: 73,
          name: "DADELDHURA",
          municipalityList: [
            {
              id: 706,
              name: "Ajaymeru Rural Municipality",
            },
            {
              id: 707,
              name: "Alital Rural Municipality",
            },
            {
              id: 708,
              name: "Amargadhi Municipality",
            },
            {
              id: 709,
              name: "Bhageshwar Rural Municipality",
            },
            {
              id: 710,
              name: "Ganayapdhura Rural Municipality",
            },
            {
              id: 711,
              name: "Nawadurga Rural Municipality",
            },
            {
              id: 712,
              name: "Parashuram Municipality",
            },
          ],
        },
        {
          id: 74,
          name: "KAILALI",
          municipalityList: [
            {
              id: 713,
              name: "Adharsha Rural Municipality",
            },
            {
              id: 714,
              name: "Badikedar Rural Municipality",
            },
            {
              id: 715,
              name: "Bogtan Rural Municipality",
            },
            {
              id: 716,
              name: "Dipayal Silgadi Municipality",
            },
            {
              id: 717,
              name: "Jorayal Rural Municipality",
            },
            {
              id: 718,
              name: "K I Singh Rural Municipality",
            },
            {
              id: 719,
              name: "Purbichauki Rural Municipality",
            },
            {
              id: 720,
              name: "Sayal Rural Municipality",
            },
            {
              id: 721,
              name: "Shikhar Municipality",
            },
          ],
        },
        {
          id: 75,
          name: "KANCHANPUR",
          municipalityList: [
            {
              id: 722,
              name: "Bannigadhi Jayagadh Rural Municipality",
            },
            {
              id: 723,
              name: "Chaurpati Rural Municipality",
            },
            {
              id: 724,
              name: "Dhakari Rural Municipality",
            },
            {
              id: 725,
              name: "Kamal Bazar Municipality",
            },
            {
              id: 726,
              name: "Mangalsen Municipality",
            },
            {
              id: 727,
              name: "Mellekh Rural Municipality",
            },
            {
              id: 728,
              name: "Panchadeval Binayak Municipality",
            },
            {
              id: 729,
              name: "Ramaroshan Rural Municipality",
            },
            {
              id: 730,
              name: "Sa Municipality hebagar Municipality",
            },
            {
              id: 731,
              name: "Turmakhad Municipality",
            },
          ],
        },
        {
          id: 76,
          name: "DOTI",
          municipalityList: [
            {
              id: 732,
              name: "Bardagoriya Rural Municipality",
            },
            {
              id: 733,
              name: "Bhajani Municipality",
            },
            {
              id: 734,
              name: "Chure Rural Municipality",
            },
            {
              id: 735,
              name: "Dhangadhi Upamaha Municipality",
            },
            {
              id: 736,
              name: "gaurignaga Rural Municipality",
            },
            {
              id: 737,
              name: "ghodaghodi Rural Municipality",
            },
            {
              id: 738,
              name: "Godawari Municipality",
            },
            {
              id: 739,
              name: "Janaki Rural Municipality",
            },
            {
              id: 740,
              name: "Joshipur Rural Municipality",
            },
            {
              id: 741,
              name: "Kailari Rural Municipality",
            },
            {
              id: 742,
              name: "Lamki Chuha Municipality",
            },
            {
              id: 743,
              name: "Mohanyal Rural Municipality",
            },
            {
              id: 744,
              name: "Tikapur Municipality",
            },
          ],
        },
        {
          id: 77,
          name: "ACHHAM",
          municipalityList: [
            {
              id: 745,
              name: "Bedkot Municipality",
            },
            {
              id: 746,
              name: "Belauri Municipality",
            },
            {
              id: 747,
              name: "Beldandi Rural Municipality",
            },
            {
              id: 748,
              name: "Bhimdatta Municipality",
            },
            {
              id: 749,
              name: "Krishnapur Municipality",
            },
            {
              id: 750,
              name: "Laljhadi Rural Municipality",
            },
            {
              id: 751,
              name: "Punarbas Municipality",
            },
            {
              id: 752,
              name: "Shuklaphanta Municipality",
            },
            {
              id: 753,
              name: "Mahakali Municipality",
            },
          ],
        },
      ],
    },
  ],
};
